var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.displayCartNotification
      ? _c(
          "div",
          {
            staticClass: "nti-cart-notification__overlay",
            on: { click: _vm.closeNotification },
          },
          [
            _c(
              "div",
              { staticClass: "nti-cart-notification__overlay-wrapper" },
              [
                _c("article", { staticClass: "nti-cart-notification" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.getCartNotificationData),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass:
                        "nti-cart-notification__confirmation__bottom",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "nti-cart-notification__confirmation__button-container",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "nti-button nti-button--large-text nti-button--no-border pardotTrackClick",
                              attrs: { "aria-label": "Continue shopping" },
                              on: {
                                click: [
                                  _vm.continueShopping,
                                  _vm.closeNotification,
                                ],
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.continueShoppingLabel) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "nti-button nti-button--large-text nti-button__link pardotTrackClick",
                              attrs: {
                                href: _vm.toBasketUrl,
                                "aria-label": "Go to basket",
                              },
                            },
                            [
                              _c("p", [_vm._v(_vm._s(_vm.toBasketLabel))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nti-svg__container-small" },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 320 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }